class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-results]');
    this.noResults = this.querySelector('[data-no-results]');
    this.allResultsLabel = this.dataset.viewAll;

    this.redirectsPairs = {
      //'return' :'https://redirect.url'
    };
  }

  connectedCallback() {
    this.addDeligatedEventListener();
  }

  addDeligatedEventListener() {
    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    this.input.addEventListener('keydown', (e) => {
      const searchTerm = this.input.value.trim();
      if (e.key === 'Enter') {
        for (const term in this.redirectsPairs) {
          if (searchTerm == term) {
            e.preventDefault()
            window.location.href = this.redirectsPairs[term];
          }
        }
      }
    });
  }
  
  onChange() {
    const searchTerm = this.input.value.trim();
    this.getSearchResults(searchTerm);
  }

  updateSearchResults(results, searchTerm) {
    this.predictiveSearchResults.innerHTML = `
      <div data-predictive-results>
        <div class="flex flex-col items-center gap-6">
          <ul role="listbox" aria-label="predictive search products" class="flex flex-col w-full">
            ${results.map((product) => product && `
              <li role="option">
                <intersection-loader 
                  data-url="/products/${product.handle }" 
                  data-section-id="product-search-tile"
                ></intersection-loader>
                <template data-loader="product-search-tile">
                  <div class="w-full h-28 bg-black/5 rounded-lg mb-3 animate-pulse"></div>
                </template>
              </li>
              `).join('')}
          </ul>
          <a href="/search?q=${searchTerm}&options%5Bprefix%5D=last&type=product" class=" button-secondary w-full text-center no-underline">${this.allResultsLabel}</a>  
        </div>
      </div>`
  }

  async getSearchResults(searchTerm) {
    await fetch(`${window.Shopify.routes.root}search/suggest.json?q=${searchTerm}&resources[limit]=3&resources[type]=product&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,tag,variants.title,variants.sku`)
    .then((response) => response.json())
      .then((suggestions) => {
        if (suggestions.resources.results.products.length == 0 ) {
          this.predictiveSearchResults.style.display = 'none';
          this.noResults.querySelector('[data-search-title]').innerHTML = `'${searchTerm}'`
          this.noResults.style.display = 'block';
        } else {
          this.predictiveSearchResults.style.display = 'block';
          this.noResults.style.display = 'none';
          const productSuggestions = suggestions?.resources?.results?.products.filter(({ tags }) => !tags.find(x => x === 'base_product') && !tags.find(x => x === 'hide'));
          this.allTitles = `${productSuggestions.map(({ title }) => title).join(',').split(',').filter(x => x.length > 1).map((x) => x).join(',')}`;
          this.updateSearchResults(productSuggestions, searchTerm);
        }
      }
    )
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    document.querySelector('[data-action=close-search]').click()
  }
}

customElements.define('predictive-search', PredictiveSearch);
